import { useState, useEffect } from 'react';

const About = () => {
    const [aboutImage, setAboutImage] = useState(null);

    useEffect(() => {
        fetch('/api/settings/aboutImage')
            .then(res => res.json())
            .then(data => {
                if (data.value) {
                    setAboutImage(data.value);
                }
            })
            .catch(err => console.log('No about image set'));
    }, []);

    return (
        <section id="about" className="section about">
            <div className="section-inner">
                <h2 className="title title-h2">About<br />RDS Studio</h2>
                <h3 className="subtitle subtitle-h3">South Africa's Boutique Web Development, Digital Marketing &amp; Automation Agency</h3>
                <p className="description">
                    RDS Studio is a boutique digital agency based in Centurion — combining deep technical expertise with strategic marketing intelligence. We specialise in custom web development, performance-driven digital marketing, and intelligent business automation that delivers measurable results for clients across South Africa and internationally.
                </p>
                <div className="about-content">
                    <div className="about-text">
                        <p>Built on the principle that businesses deserve exceptional digital services with transparent communication and competitive pricing, RDS Studio maintains the agility of a boutique agency while delivering enterprise-level solutions through our skilled team and strategic partnerships.</p>
                        <p style={{ marginTop: 'var(--space-4)', fontStyle: 'italic', color: 'var(--color-secondary)' }}>In South Africa's rapidly evolving digital landscape, staying ahead requires constant innovation. Our team monitors emerging technologies, algorithm updates, and industry best practices daily -- ensuring your digital assets remain competitive while you focus on growing your business.</p>
                        <ul>
                            <li>Headquartered in Centurion, serving clients across SA and internationally</li>
                            <li>Web development, digital marketing &amp; automation under one roof</li>
                            <li>Certified specialists in WordPress, React, and cloud infrastructure</li>
                            <li>Direct access to senior developers and strategists</li>
                            <li>Strategic partnerships with design and content specialists</li>
                        </ul>
                        <p>We partner with businesses of all sizes -- from startups to established enterprises -- delivering professional digital solutions that scale with your growth.</p>
                    </div>
                    <div className="about-image">
                        {aboutImage ? (
                            <img 
                                src={aboutImage} 
                                alt="About Me" 
                                style={{
                                    position: 'absolute',
                                    inset: 0,
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    borderRadius: '8px'
                                }}
                            />
                        ) : (
                            <div style={{
                                position: 'absolute',
                                inset: 0,
                                background: 'linear-gradient(135deg, rgba(181,254,217,0.06), rgba(123,160,152,0.04))',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '8px'
                            }}>
                                <i className="fas fa-user" style={{
                                    fontSize: '4rem',
                                    color: 'var(--color-secondary)'
                                }}></i>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;